"use client";

import { createContext, type ReactNode, useContext } from "react";

/**
 * `held` — the page is not in view yet, module reveals stay wound up.
 * `revealing` — play the reveal once.
 * `done` — this page has already played it; render the finished state at once.
 */
export type ModuleRevealGateState = "held" | "revealing" | "done";

const ModuleRevealGateContext =
  createContext<ModuleRevealGateState>("revealing");

/** Holds module-owned reveals until the page they sit on has scrolled into view. */
export function ModuleRevealGateProvider({
  state,
  children,
}: {
  state: ModuleRevealGateState;
  children: ReactNode;
}) {
  return (
    <ModuleRevealGateContext.Provider value={state}>
      {children}
    </ModuleRevealGateContext.Provider>
  );
}

/** `revealing` by default, so consumers outside the handyout reader animate as before. */
export function useModuleRevealGate() {
  return useContext(ModuleRevealGateContext);
}
